import * as React from "react"
import { createPortal } from "react-dom"
import { requestPasswordReset } from "../auth/api"

const inputClass =
  "w-full border-2 border-slate-200 rounded-xl text-center p-2 mt-1 bg-white text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-cor-base transition-colors"

export default function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = React.useState("")
  const [error, setError] = React.useState("")
  const [success, setSuccess] = React.useState("")
  const [loading, setLoading] = React.useState(false)

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) onClose()
  }

  React.useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose()
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [onClose])

  async function handleSubmit(e) {
    e.preventDefault()
    setError("")
    setSuccess("")

    if (!email.trim()) {
      setError("Informe o e-mail de login.")
      return
    }

    try {
      setLoading(true)
      const data = await requestPasswordReset(email.trim())
      setSuccess(
        data?.message ||
          "Se o e-mail estiver cadastrado, você receberá instruções em breve.",
      )
      setEmail("")
    } catch (err) {
      setError(err?.message || "Não foi possível enviar a solicitação.")
    } finally {
      setLoading(false)
    }
  }

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}>
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl">
        <div className="flex items-center justify-between px-6 py-4 bg-cor-base rounded-t-2xl">
          <h2 className="text-xl font-oswald font-semibold text-white tracking-wide">
            Esqueci minha senha
          </h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-2xl leading-none transition-colors"
            aria-label="Fechar"
            type="button">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="px-6 py-5 grid gap-4">
          <p className="text-sm text-slate-600">
            Informe o e-mail usado no login. Enviaremos um link de uso único
            para redefinir a senha.
          </p>
          <p className="text-xs text-slate-500">
            Você receberá o código no e-mail cadastrado para login.
          </p>

          <div>
            <label className="text-sm font-semibold text-slate-500 uppercase tracking-wide">
              E-mail de login
            </label>
            <input
              type="email"
              className={inputClass}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoFocus
            />
          </div>

          {error && (
            <p className="text-red-600 text-center text-sm font-semibold">
              {error}
            </p>
          )}
          {success && (
            <p className="text-green-600 text-center text-sm font-semibold">
              {success}
            </p>
          )}

          <div className="flex gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2.5 rounded-xl border-2 border-slate-200 text-slate-600 font-semibold hover:bg-slate-50 transition-all">
              Fechar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 py-2.5 rounded-xl bg-cor-base text-white font-semibold hover:scale-[1.02] active:scale-[.97] transition-all disabled:opacity-60 disabled:cursor-not-allowed">
              {loading ? "Enviando..." : "Enviar link"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  )
}
